import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import styles from "./TechCardStyles";
import { getCalculations } from "../../utils/services/projectService";
//import KKCompactR05 from "./images/R05Design.png";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FanChartReactPDF from "./fanChart/FanChartReactPDF";
import AboutTech from "./Components/AboutTech";
import GenProdSpec from "./Components/GenProdSpec";
import EuroventInfo from "./Components/EuroventInfo";
// import ConnectingEhaIn from "./Components/ConnectingEhaIn";
// import CompactFilterEha from "./Components/CompactFilterEha";
import HeatExchangerEha from "./Components/HeatExchangerEha";
// import PlugFanEha from "./Components/PlugFanEha";
// import ConnectingEhaOut from "./Components/ConnectingEhaOut";
// import ConnectingSupIn from "./Components/ConnectingSupIn";
// import CompactFilterSup from "./Components/CompactFilterSup";
import HeatExchangerSup from "./Components/HeatExchangerSup";
// import PlugFanSup from "./Components/PlugFanSup";
// import ConnectingSupOut from "./Components/ConnectingSupOut";
import Ecodesign from "./Components/Ecodesign";
import TechCardHeader from "./Components/TechCardHeader";
import TechCardFooter from "./Components/TechCardFooter";

const today = new Date();
const date =
  today.getDate() + "-" + (today.getMonth() + 1) + "-" + today.getFullYear();
const dayNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
const day = today.getDay();

const TechCardContent = ({ id, revNum, heatRecovery }) => {
  const [techData, setTechData] = useState(null);
  useEffect(() => {
    getCalculations(id, revNum).then((res) => {
      setTechData(res.data);
    });
  }, [id, revNum]);

  console.log(heatRecovery);
  if (!techData) return null;

  return (
    <Document title={`TecnicalCard${id}`} author="Climate Prime">
      <Page size="A4" style={styles.page}>
        <TechCardHeader styles={styles} />
        <View style={styles.section}>
          <AboutTech styles={styles} techData={techData} date={date} />
          <GenProdSpec styles={styles} techData={techData} />
          <EuroventInfo styles={styles} techData={techData} />
          <View style={styles["img-center"]}>
            {/*<Image src={KKCompactR05} alt="test" style={{ width: "40%" }} />*/}
          </View>
          <View style={{ ...styles.heading, marginBottom: "15px" }} break>
            <Text style={styles.title}>EXHAUST SIDE</Text>
          </View>
          {/* <ConnectingEhaIn techData={techData} styles={styles} /> */}
          {/* <CompactFilterEha styles={styles} techData={techData} /> */}
          <HeatExchangerEha
            styles={styles}
            techData={techData}
            heatRecovery={heatRecovery}
          />
          {/* <PlugFanEha styles={styles} techData={techData} /> */}
          <View style={styles["img-center"]}>
            <FanChartReactPDF />
          </View>
          {/* <ConnectingEhaOut styles={styles} techData={techData} /> */}

          <View style={{ ...styles.heading, marginBottom: "10px" }} break>
            <Text style={styles.title}>SUPPLY SIDE</Text>
          </View>

          {/* <ConnectingSupIn techData={techData} styles={styles} /> */}
          {/* <CompactFilterSup techData={techData} styles={styles} /> */}
          <HeatExchangerSup
            styles={styles}
            techData={techData}
            heatRecovery={heatRecovery}
          />
          {/* <PlugFanSup styles={styles} techData={techData} /> */}

          <View style={styles["img-center"]}>
            <FanChartReactPDF />
          </View>

          {/* <ConnectingSupOut styles={styles} techData={techData} /> */}
          <Ecodesign
            styles={styles}
            techData={techData}
            heatRecovery={heatRecovery}
          />
        </View>
        <TechCardFooter dayNames={dayNames} date={date} day={day} />
      </Page>
    </Document>
  );
};

const TechCardLink = ({ id, revNum, heatRecovery }) => {
  return (
    <PDFDownloadLink
      document={
        <TechCardContent id={id} revNum={revNum} heatRecovery={heatRecovery} />
      }
      fileName="tehnicalCard.pdf"
    >
      <PictureAsPdfIcon sx={{ color: "#343734", width: "26px" }} />
    </PDFDownloadLink>
  );
};
export default TechCardLink;
